import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import { Invitation } from './components/Invitation'
import { Register } from './components/Register'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='invitation' element={<Invitation />} />
      <Route path='registration' element={<Registration />} />
      <Route path='invitation' element={<Invitation />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      {/* <Route path='trial-registration' element={<TrialRegistration/>} /> */}
      <Route path='signup' element={<Register/>}/>
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
